import { routers } from "@/utils/constants";

const routes: Array<any> = [
  {
    path: "/",
    name: "ProspectHome",
    component: () => import("@/components/prospect/prospectHome.vue"),
  },
  {
    path: "/prospectEmailThanks",
    name: "ProspectEmailThanks",
    meta: {
      requiresPreProspectAuth: true,
    },
    component: () => import("@/components/prospect/prospectEmailThanks.vue"),
  },
  {
    path: "/prospectVerifyEmail",
    name: "ProspectVerifyEmail",
    meta: {
      requiresProspectAuth: true,
    },
    component: () => import("@/components/prospect/prospectVerifyEmail.vue"),
  },
  {
    path: "/prospect/verify/callback",
    name: "ProspectCallback",
    component: () => import("@/pages/prospect/prospectCallback.vue"),
  },
  {
    path: "/prospectExistingOrg",
    name: "ProspectExistingOrg",
    meta: {
      requiresPreProspectAuth: true,
    },
    component: () => import("@/components/prospect/prospectExistingOrg.vue"),
  },
  {
    path: "/prospectExistingUser",
    name: "ProspectExistingUser",
    meta: {
      requiresPreProspectAuth: true,
    },
    component: () => import("@/components/prospect/prospectExistingUser.vue"),
  },
  {
    path: "/prospect/questions",
    name: "ProspectQuestions",
    meta: {
      requiresProspectAuth: true,
    },
    component: () =>
      import("@/components/prospect/prospectQuestions/prospectQuestions.vue"),
  },
  {
    path: "/prospect/responses",
    name: "MyResponse",
    meta: {
      requiresProspectAuth: true,
    },
    component: () =>
      import("@/components/prospect/prospectQuestions/myResponse.vue"),
  },
  {
    path: "/prospect/createaccount",
    name: "CreateAccount",
    meta: {
      requiresProspectAuth: true,
    },
    component: () => import("@/components/prospect/prospectCreateAccount.vue"),
  },
  {
    path: "/user/login",
    name: "Login",
    component: () => import("@/components/user/login.vue"),
  },
  {
    path: "/user/forgotPassword",
    name: "ForgotPassword",
    component: () => import("@/components/user/forgotPassword.vue"),
  },
  {
    path: "/user/twoStepAuthenticationSetup",
    name: "TSASetup",
    meta: {
      requiresPreUserAuth: true,
    },
    component: () => import("@/components/user/tsaSetup.vue"),
  },
  {
    path: "/user/twoStepAuthentication",
    name: "TwoStepAuthentication",
    meta: {
      requiresPreUserAuth: true,
    },
    component: () => import("@/components/user/twoStepAuthentication.vue"),
  },
  {
    path: "/user/verify",
    name: "MFASelection",
    component: () => import("@/components/user/mfaSelectionPage.vue"),
  },
  {
    path: "/user/mfaSelection",
    name: "MFASelection",
    component: () => import("@/components/user/mfaSelectionPage.vue"),
  },
  {
    path: "/welcome",
    name: "Landing",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/components/user/landing.vue"),
  },
  {
    path: "/org/manage",
    name: "OrgManagement",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/orgs/orgManagement.vue"),
  },
  {
    path: "/settings/organisation/details",
    name: "OrganisationDetail",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/orgs/orgDetail.vue"),
  },
  {
    path: "/settings/team/members",
    name: "TeamMembers",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/team/membersManagement.vue"),
  },
  {
    path: "/settings/team/roles",
    name: "TeamRoles",
    meta: {
      requiresAuth: true,
    },

    children: [
      {
        path: "",
        name: "TeamRoles",
        component: () => import("@/pages/team/rolesManagement.vue"),
      },
      {
        path: "manage/:roleId",
        name: "ManageRole",
        component: () => import("@/pages/team/manageRole.vue"),
      },
    ],
  },
  {
    path: "/settings/domains",
    name: "DomainsManagement",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/domains/domainManagement.vue"),
  },
  {
    path: "/settings/organisation/profile",
    name: "OrganisationProfile",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/orgs/profile.vue"),
  },
  {
    path: "/settings/organisation/access",
    name: "ManageAccess",
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import("@/pages/orgs/manageAccess.vue"),
  },
  {
    path: "/user/password/reset/callback",
    name: "ResetPasswordCallback",
    component: () => import("@/components/user/resetPasswordCallback.vue"),
  },
  {
    path: "/user/password/reset",
    name: "ResetPassword",
    component: () => import("@/components/user/resetPassword.vue"),
  },
  {
    path: "/user/verify/email/callback",
    name: "VerifyEmailCallback",
    component: () => import("@/components/user/verifyEmailCallback.vue"),
  },
  {
    path: "/user/verify/email",
    name: "VerifyEmail",
    component: () => import("@/components/user/verifyEmail.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/home/dashboard.vue"),
  },
  {
    path: routers.settingsSetup,
    name: "SettingSetup",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/home/setup.vue"),
  },
  {
    path: "/assess/manage",
    name: "Assessment",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/scanning/assessment.vue"),
  },
  {
    path: "/assess/input",
    name: "AssessmentInput",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/scanning/assessmentInput.vue"),
  },
  {
    path: "/assess/roadmap",
    name: "AssessmentRecommended",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/recommendations/recommendations.vue"),
  },
  {
    path: "/assess/benchmark",
    name: "AssessmentBenchmark",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/benchmarking/benchmarking.vue"),
  },
  {
    path: "/assess/vendor/template",
    name: "AssessmentVendorCreate",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/vendor/vendorAssessmentsCreate.vue"),
  },
  {
    path: "/assess/vendor/external/callback",
    name: "AssessmentVendorExternalCallback",
    component: () => import("@/pages/vendor/vendorAssessmentsCallback.vue"),
  },
  {
    path: "/checklist/requested/callback",
    name: "AssessmentRequestedCallback",
    component: () => import("@/pages/vendor/vendorRequestedCallback.vue"),
  },
  {
    path: "/assess/vendor/external/input",
    name: "AssessmentVendorInput",
    component: () => import("@/pages/vendor/vendorAssessmentsInput.vue"),
  },
  {
    path: "/assess/vendor/external/submit",
    name: "AssessmentVendorSubmit",
    component: () => import("@/pages/vendor/vendorAssessmentsSubmit.vue"),
  },
  {
    path: "/assess/vendor/external/sorry",
    name: "VendorAssessmentsExternalSorry",
    component: () =>
      import("@/pages/vendor/vendorAssessmentsExternalSorry.vue"),
  },
  {
    path: "/assess/vendor/manage",
    name: "AssessmentVendor",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/vendor/vendorAssessments.vue"),
  },
  {
    path: "/scan/scanning",
    name: "ScanScanning",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/scanning/scanning.vue"),
  },
  {
    path: "/scan/techassets",
    name: "ScanTechAssets",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/scanning/technologyAndAssets.vue"),
  },
  {
    path: "/risk/dashboard",
    name: "RiskDashboard",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/risk/riskDashboard.vue"),
  },
  {
    path: "/compliance/audits",
    name: "ComplianceAudits",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/compliance/complianceAudit.vue"),
  },
  {
    path: "/pentest/pentests",
    name: "PentestPentests",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/pentest/pentests.vue"),
  },
  {
    path: "/insurance/questionnaires",
    name: "Questionnaires",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/insurance/insuranceQuestionnaires.vue"),
  },
  {
    path: "/reports/chr",
    name: "ShareProfile",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/share/cyberProfile.vue"),
  },
  {
    path: "/share/external",
    name: "ShareExternal",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/share/externalAssessments.vue"),
  },
  {
    path: "/service/marketplace",
    name: "ServiceMarketplace",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/serviceProvider/marketPlace.vue"),
  },
  {
    path: "/learn/help",
    name: "LearnHelp",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/learn/learnHelp.vue"),
  },
  {
    path: "/org/verify/email/callback",
    name: "verifyorganisation",
    component: () =>
      import("@/components/orgManagement/verifyorganisation.vue"),
  },
  {
    path: "/org/domain/verify/callback",
    name: "VerifyDomain",
    component: () => import("@/components/team/members/verifyDomainEmail.vue"),
  },
  {
    path: "/assess/vendor/review/:assessmentId",
    name: "AssessmentVendorReview",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/pages/vendor/vendorAssessmentsReview.vue"),
  },
];

export default routes;
